import { Typography } from '@dapp/multi-lib/sdaoui/Typography';
import { Icon } from '@dapp/multi-lib/sdaoui/Icon';
import Link from 'next/link';
import { HorizontalLine } from '@dapp/multi-lib/sdaoui/HorizontalLine';
import React from 'react';
import useIsMobile from '@dapp/multi-lib/ui/shared-hooks/useIsMobile';
import { twMerge } from 'tailwind-merge';
import { getStaticAssetUrl } from 'utils/url';

interface FooterProps {
  className?: string;
}

export const Footer = ({ className }: FooterProps) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <MobileFooter />;
  }

  return <TabletAndDesktopFooter className={className} />;
};

const TabletAndDesktopFooter = ({ className }: { className?: string }) => {
  return (
    <div
      className={twMerge(
        'flex w-full max-w-[100rem] flex-col items-center px-2 pb-3 lg:px-7 xl:px-[90px]',
        className
      )}
    >
      <HorizontalLine className='mb-5 mt-8' />
      <div className='flex w-full flex-row flex-wrap justify-between gap-4'>
        <SocialLinks />
        <Links className='ml-auto' />
      </div>
    </div>
  );
};

const MobileFooter = () => {
  return (
    <div className='mt-24 flex w-full flex-col gap-4 pb-3 max-lg:px-3'>
      <SocialLinks />
      <HorizontalLine />
      <Links />
    </div>
  );
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SocialLinks = () => {
  return (
    <div className='flex flex-row items-center gap-4 text-[#808080]'>
      <Typography as='p' className='text-[0.75rem] text-inherit'>
        Follow us
      </Typography>
      {/*<Link target='_blank' href=''>*/}
      {/*  <Icon icon='github' color='inherit' />*/}
      {/*</Link>*/}
      <Link target='_blank' href='https://x.com/Singularity_fi'>
        <Icon icon='x' color='inherit' />
      </Link>
      <Link target='_blank' href='https://t.me/Singularity_Fi'>
        <Icon icon='telegram' color='inherit' />
      </Link>
      {/*<Link target='_blank' href=''>*/}
      {/*  <Icon icon='discord' color='inherit' />*/}
      {/*</Link>*/}
      {/*<Link target='_blank' href=''>*/}
      {/*  <Icon icon='facebook' color='inherit' />*/}
      {/*</Link>*/}
      {/*<Link target='_blank' href=''>*/}
      {/*  <Icon icon='medium' color='inherit' />*/}
      {/*</Link>*/}
    </div>
  );
};

interface LinkProps {
  className?: string;
}

const Links = (props: LinkProps) => {
  const { className } = props;
  return (
    <div
      className={twMerge(
        'flex flex-row flex-wrap items-center gap-3 text-[0.75rem] text-[#808080]',
        className
      )}
    >
      <Link
        target='_blank'
        className='text-inherit'
        href={getStaticAssetUrl('/sfi/static/pdf/terms_and_conditions.pdf')}
      >
        Terms & Conditions
      </Link>
      <Link
        target='_blank'
        className='text-inherit'
        href={getStaticAssetUrl('/sfi/static/pdf/privacy_policy.pdf')}
      >
        Privacy Policy
      </Link>
      <Link
        target='_blank'
        className='text-inherit'
        href={getStaticAssetUrl('/sfi/static/pdf/cookie_policy.pdf')}
      >
        Cookie Policy
      </Link>
    </div>
  );
};
